import {Component, OnInit, ViewChild, ViewEncapsulation} from '@angular/core';
import {MenuItem} from 'primeng/api';
import {TranslateService} from '@ngx-translate/core';
import {TieredMenu} from 'primeng/tieredmenu';
import {LoginService} from '@services/login.service';

@Component({
  selector: 'si-top-bar-user',
  templateUrl: './top-bar-user.component.html',
  styleUrls: ['./top-bar-user.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class TopBarUserComponent implements OnInit {
  title = 'Marisol Fernández de la Vega';
  subtitle = 'Administrador | Administrador | Administrador | Administrador';
  items: MenuItem[];
  @ViewChild(TieredMenu) tieredMenu: TieredMenu;

  constructor(private translateService: TranslateService,
              private loginService: LoginService) {
  }

  ngOnInit(): void {
    this.setItems();
  }

  async setItems(): Promise<void> {
    const logoutText = await this.translateService.get('SI_LOGOUT').toPromise();
    const mockItemText = this.translateService.instant('MOCK_ITEM');

    this.items = [
      {
        label: mockItemText,
        icon: 'icon-viewheadline',
        items: [
          {label: 'Inicio', routerLink: '/', command: () => this.closeMenu()}
        ]
      },
      {
        label: logoutText,
        icon: 'icon-logout',
        command: () => this.onClickLogout()
      }
    ];
  }

  closeMenu(): void {
    this.tieredMenu.hide();
  }

  async onClickLogout(): Promise<void> {
    await this.logout();
  }

  async logout(): Promise<void> {
    await this.loginService.logout();
  }

}
